export default __webpack_public_path__ + "static/blackcliff_warbow-1302a8f945f1b7e49ccd1b0d832e623b.png";